module.exports = __webpack_public_path__ + "img/Mail-2.a9825f28.svg";